import { render, staticRenderFns } from "./GiftWrapping.vue?vue&type=template&id=c3873ee8&"
import script from "./GiftWrapping.vue?vue&type=script&lang=js&"
export * from "./GiftWrapping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports